export default __webpack_public_path__ + "static/media/aircare-4.737972b4.png";